import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../styles/AuthForm.css';
import API_BASE from '../../utils/api';
import notify from '../../utils/notify';

function ConfirmSignup() {
  const location = useLocation();
  const navigate = useNavigate();
  const passedEmail = location.state?.email || '';
  const inviteToken = location.state?.inviteToken || '';
  const [email, setEmail] = useState(passedEmail);
  const [code, setCode] = useState('');

  const handleConfirm = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_BASE}/api/auth/confirm`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code }),
      });

      const data = await res.json();
      if (res.ok) {
        notify('Email confirmed!');
        if (inviteToken) {
          navigate('/', { state: { email } });
        } else {
          // Marketing-site links preselect a plan/billing choice into
          // localStorage during signup (see Signup.js) — skip the plan
          // picker and go straight to checkout when that's the case.
          let storedPlan = null;
          try {
            storedPlan = JSON.parse(localStorage.getItem('signupPlan'));
          } catch {
            storedPlan = null;
          }
          const hasPreselectedPlan =
            storedPlan?.plan === 'standard' || storedPlan?.plan === 'premium';
          navigate(hasPreselectedPlan ? '/checkout' : '/plans', { state: { email } });
        }
      } else {
        notify(data.error || 'Confirmation failed.');
      }
    } catch (err) {
      console.error(err);
      notify('Something went wrong.');
    }
  };

  return (
    <div className="auth-form">
      <img src="/logo.png" alt="InteriorFolio Logo" className="auth-logo" />
      <form className="auth-card" onSubmit={handleConfirm}>
        <h2>Confirm Your Email</h2>
        <input
          type="email"
          placeholder="Your Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="text"
          placeholder="Verification Code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          required
        />
        <button type="submit">Confirm</button>
      </form>
    </div>
  );
}

export default ConfirmSignup;
